import { useFetch } from "@/helpers/composables/useFetch";
import { route } from "ziggy-js";

export function useMetaConversionAPI () {

    const metaProductView = (payload) => {
        useFetch(route("meta.event.product_view"))
            .post(payload)
            .json();     
    };

    const metaAddToCart = (list_items_ids) => {
        useFetch(route("meta.event.add_to_cart"))
            .post({'list_item_ids' : list_items_ids })
            .json();     
    };

    const metaPurchase = (order_id) => {
        useFetch(route("meta.event.purchase"))
            .post({'order_id' : order_id })
            .json();     
    };

    return {
        metaProductView,
        metaAddToCart,
        metaPurchase
    };
}
